import { FeatureConfig } from '@typesApp/Config'
import { ViewName, ViewNavigation } from '@typesApp/ViewNavigation'

export const baseConfig_VDFlow: FeatureConfig = {
  insuranceFlowType: 'VD_FLOW',
  disableAuthTokenForGuest: true,

  // view navigation configuration
  viewNavigation: {
    // next and previews flow
    flow: {
      intro: {
        next: 'insurance-information',
      },
      'insurance-information': {
        next: 'quote',
      },
      insurers: {
        next: 'insurance-information',
        previous: 'intro',
      },
    } as Record<ViewName, ViewNavigation>,

    // all steps in insurance flow
    steps: ['insurance-information', 'quote'],

    // resume view mapping
    resumeMapping: {
      // default resume to insurance form
      '*': 'insurance-information',

      // resume by claim record status
      READY_TO_CLAIM: 'quote',
      QUOTE_REQUESTED: 'quote',
    },
  },
}
